import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import noop from 'lodash.noop'
import { canUseDom } from '@sainsburys-tech/boltui-utils'
import { project } from '../../utils'
import Alternatives from './Alternatives'

const getCategoryId = categories => {
  if (categories[0].name !== 'Clothing') {
    return categories[categories.length - 1].id
  }

  return categories[categories.length - 2].id
}

class AlternativesContainer extends Component {
  componentDidMount = () => {
    this.getAlternatives()
  }

  componentDidUpdate = prevProps => {
    const { parentPartNumber, localisation } = this.props
    const partNumberHasChanged = parentPartNumber !== prevProps.parentPartNumber
    const localisationHasChanged =
      localisation.postcode !== prevProps.localisation.postcode ||
      localisation.storeId !== prevProps.localisation.storeId
    if (partNumberHasChanged || localisationHasChanged) {
      this.getAlternatives()
    }
  }

  getAlternatives = () => {
    const { parentPartNumber, localisation, requestAlternatives, productStore, type } = this.props
    const categories = productStore.data?.categories || [{}]
    const placement = type === 'avAlternatives' ? 'av-alternatives' : type
    const productImage = productStore.data?.media?.images[0]

    requestAlternatives({
      partNumber: parentPartNumber,
      localisation,
      categoryId: getCategoryId(categories),
      type: placement,
      productImage
    })
  }

  render = () => <Alternatives {...this.props} />
}

AlternativesContainer.propTypes = {
  parentPartNumber: PropTypes.string.isRequired,
  requestAlternatives: PropTypes.func
}

AlternativesContainer.defaultProps = {
  requestAlternatives: noop
}
const hasItems = (state, parentPartNumber, type) => {
  const { [type]: alternatives = {}, resource = {} } = state
  const { meta = {} } = resource
  const { data = {} } = alternatives
  const alternativesStore = data[parentPartNumber] || {}
  const { products = [] } = alternativesStore
  const productIdList = products.map(project.id)
  const hasLoaded = id => meta[id] && meta[id].requestDone && !meta[id].errorDetail
  const hasProducts = productIdList.some(hasLoaded)
  const hasError = id => meta[id] && meta[id].errorDetail
  const hasAllProductsErrors = productIdList.length > 0 ? productIdList.every(hasError) : false
  return { hasProducts, hasAllProductsErrors }
}

const hasRequestDone = (state, parentPartNumber, type) => {
  const { [type]: alternatives = {} } = state
  const { meta = {} } = alternatives
  const alternativesMeta = meta[parentPartNumber] || {}
  const { requestDone = false } = alternativesMeta
  return requestDone
}

const checkAlternativesInCategory = (state, parentPartNumber, type) => {
  const { resource = {}, [type]: alternativeStoreName, productStore } = state
  const { data: productData = {} } = productStore
  const { data: resourceData = {} } = resource
  const { data: alternativeData = {} } = alternativeStoreName
  const alternativesStore = alternativeData[parentPartNumber] || {}
  const { products = [] } = alternativesStore

  const categories = productData.breadcrumb

  if (categories) {
    const categoryId = getCategoryId(categories)
    return products.some(({ id }) => {
      const alternativeCategory = resourceData[id]?.taxonomy?.breadcrumb?.attributes?.categories
      if (alternativeCategory) {
        const alternativeCategoryId = getCategoryId(alternativeCategory)
        return alternativeCategoryId === categoryId
      }
      return true
    })
  }
  return true
}

const mapStateToProps = (state, ownProps) => {
  const { parentPartNumber, type } = ownProps
  const {
    storeLocator = { data: {} },
    featuredProducts = {},
    bazaarVoiceReview = {},
    bazaarVoiceQuestionAnswer = {},
    productStore = {},
    specialOffersCreator = {},
    [type]: alternativeStoreName = {}
  } = state
  const { data = {}, meta = {} } = alternativeStoreName
  const { mvts } = meta[parentPartNumber] || { mvts: [] }
  const alternativesStore = data[parentPartNumber] || {}
  const { products = [] } = alternativesStore
  const hasAlternativesInCategory =
    type !== 'similiarItems' || checkAlternativesInCategory(state, parentPartNumber, type)
  const statusCheck = hasItems(state, parentPartNumber, type)
  const { hasProducts, hasAllProductsErrors } = statusCheck
  const hasAlternativesRequestDone = hasRequestDone(state, parentPartNumber, type)
  const onClient = canUseDom()
  const featuredProductsData = featuredProducts.data || {}
  const featuredProductsStore = featuredProductsData[parentPartNumber] || {}
  const bazaarVoiceReviewStore = bazaarVoiceReview.data || {}
  const bazaarVoiceQuestionAnswerStore = bazaarVoiceQuestionAnswer.data || {}
  const postcode = storeLocator.data.deliveryPostcode || ''
  const storeId = storeLocator.data.storeNumber || ''
  const props = {
    products,
    hasProducts,
    hasAllProductsErrors,
    hasAlternativesRequestDone,
    hasAlternativesInCategory,
    onClient,
    mvts,
    storeLocator: storeLocator.data,
    alternativesStore,
    featuredProductsStore,
    bazaarVoiceReviewStore,
    bazaarVoiceQuestionAnswerStore,
    productStore,
    localisation: {
      postcode,
      storeId
    },
    specialOffersCreator: specialOffersCreator.data
  }
  return props
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { fetchRequest, updateRequest } = ownProps
  const props = {
    requestAlternatives: payload => dispatch(fetchRequest(payload)),
    updateAlternatives: payload => dispatch(updateRequest(payload))
  }
  return props
}

export default connect(mapStateToProps, mapDispatchToProps)(AlternativesContainer)
